import { Component, OnInit, ElementRef, ViewChild, ɵConsole } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';
import { AddContent, PublishTo } from './contentmanagement-class/addcontent';
import { Topicdetails } from './contentmanagement-class/Topicdetails';
import { IList } from './contentmanagement.list';
import { environment } from '../../environments/environment';
import { ContentmanagementService } from '../service/content.management.service';
import { DistributeGroupContent, DistributeClassContent } from '../coursematerial/teachercoursematerialsearch/teacherdistribute/classes/distributecontent';
import { MyErrorHandler } from '../../../../tools/src/lib/errorhandler/errorhandler';

import { ContentData } from './contentmanagement-class/contentdata';
import { FilterCriteria } from './contentmanagement-class/filtercriteria';
import { MultiselectProjectValue } from './contentmanagement-class/multiselectprojectvalue';
import { ToolsService } from '../../../../tools/src/lib/tools.service';
import * as languageConfig from '../../../../../src/assets/i18n/configuration/configuration.json';

declare function getCreateAssetsResponse(url, groupId, contentType, fileName, content, fileType, filseSize, title, description, tag, language, msdpFileType, callback): any;
declare function getUpdateAssetsResponse(url, assetId, groupId, contentType, fileName, content, fileType, filseSize, title, description, tag, language, msdpFileType, callback): any;
declare function getDeleteAssetsResponse(url, assetId, callback): any;
declare function deleteGroupByAssetIdResponse(url, assetId, groupId, callback): any;
declare function xmlToJson(xml): any;

import { TabGroup } from '@eds/vanilla';
import { Dialog } from '@eds/vanilla';
import { Dropdown } from '@eds/vanilla/dropdown/Dropdown';
import { Menu } from '@eds/vanilla/dropdown/Menu';
import { sequenceEqual } from 'rxjs/operators';
import { map } from 'underscore';
import { newArray } from '@angular/compiler/src/util';

@Component({
  selector: 'app-contentmanagement',
  templateUrl: './contentmanagement.component.html',
  styleUrls: ['./contentmanagement.component.css'],
  providers: [
    ContentmanagementService, ToolsService
  ]
})
export class ContentmanagementComponent implements OnInit {
  projectContent: any;
  msdpFileType: string;
  selectedLanguage: any;
  message: any;
  gridViewA = true;
  gridViewF = true;
  gridViewM = true;
  myview: string;
  titleMessage: string;
  subTitleMessage: string;
  detailMessage: string;
  detailMessage1: string;
  detailMessage2: string;
  environment: any;
  _curriculumData: any;
  btnStatusAdd = false;
  btnTextCancel = '';
  btnTextAdd = '';
  @ViewChild('editContentModel') editContentModel: ElementRef;
  @ViewChild('addContentModel') addContentModel: ElementRef;
  @ViewChild('viewContentModel') viewContentModel: ElementRef;
  @ViewChild('distributeContentModel') distributeContentModel: ElementRef;

  @ViewChild('#star') staricon: ElementRef;
  @ViewChild('successModal') successModal: ElementRef;
  // @ViewChild('classgroupDropdown') classgroupDropdown: ElementRef;
  // @ViewChild('classgroupMenu') classgroupMenu: ElementRef;

  errorHandler: MyErrorHandler;
  project_id = '';
  projects: any;
  years: any;
  yearsDD: any;
  grades: any[];
  gradesDD=[];
  gradesDD1: any[];
  types: any;
  subjects: any;
  subjectsDD: any;
  sources: any;
  sourcesDD: any;
  topics: any;
  languages: any;
  allLanguages: any;
  ayears=[];
  agrades=[]
  fagrades=[];
  fyears=[];
  fsubject: any;
  fsource: any;
  ftopics: any;
  flanguages: any;
  ftype: any;
  fgrades: any;
  fYears: any;
  ftempSubArr = [];
  fTempGradeArr = [];
  ftempYears = [];
  ftempLangArr = [];
  ftempSourceArr = [];
  ftempType = [];
  msubjects: any;
  mtypes: any;
  mgrades: any;
  mlanguages: any;
  msources: any;
  mYears:any;
  cmviewType = '';
  currentTab = '';
  public filterCreteria;
  public afilterCreteria;
  public ffilterCreteria;
  public mfilterCreteria;
  public dfilterCreteria;
  highLightRow;
  defaultValue = 0;
  showLoader: boolean;
  firstTime: boolean;
  tagsString: string;
  tileString: string;
  public isMediaUpdated: boolean;
  showFileUploadLoader: boolean;
  projectValidation;
  groupListData: any;
  classRoomList: any;
  _classId = '';
  userDetails: any;
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  isUpdate: boolean;
  distributedWithClass: any;
  distributedWithGroup: any;
  partners;

  ilist: IList[];
  addNewContentModel: AddContent;
  addNewContentModelSubmit: AddContent;

  fileFormat = true;
  page = 1;
  p1 = 1;
  p2 = 1;
  p3 = 1;
  p4 = 1;
  p5 = 1;
  p6 = 1;
  noOfItems = 9;
  cterm = '';
  deleted = false;
  term: any = {
    all: '',
    fav: '',
    my: '',
    dist: ''
  };

  distributeGradeFilterList  = [];
  distributeClassFilterList = [];

  allowedTypesArr = [];

  public errorMessage: any = null;
  public count = 0;

  public data;
  public event;
  public contentList;
  public favouriteList;
  public teacherdistributeList;
  public distContentList;
  public teachercontentList;
  public mycontentList;
  public contentDetails;
  public isContentFound: boolean;

  public filterQuery = '';
  public rowsOnPage = 10;
  public sortByVar = '';
  public sortOrder = 'asc';
  public fileName;
  public fileExtension;
  public content;
  public fileType;
  public contentType;
  public fileSize;

  validationMsg: string;
  groupList = [];
  classList = [];
  contentId: string;
  classId: string;
  isGroupTab = false;
  isClassTab = false;
  isAllSelected = false;
  isAllDeSelected = false;
  loaded = false;

  distributeContentToClass: DistributeClassContent;
  distributeContentToGroup: DistributeGroupContent;
  disableDistribute = true;

  selectedProjects = [];
  selectedProjectsMap = {};
  selectedProjectsChecked = [];
  loggedInUser: any;
  gridSelectedA = true;
  gridSelectedF = true;
  gridSelectedM = true;

  // dgradeSelectConfig:any;
  // dclassSelectConfig:any;
  // classSelectConfig:any;
  // yearSelectConfig:any;
  // subjectSelectConfig:any;
  // languageSelectConfig:any;
  // sourceSelectConfig:any;
  // typeSelectConfig:any;   
  listBy: any;
  listBySelectConfig = {
    placeholder: 'List by',
    displayKey: 'name',
    search: false,
    limitTo: 12
  };
  

  listByOptions = [
    {name: 'List by class', state: true},
    {name: 'List by content', state: false}
  ];

  /* Sorting variables */
  propertyName: string;
  propertyNameSorting: string;
  orderType = true;
  isSorted = false;
  sortedClass: string;
  selectedDatasource: any;
  atypes: any[];
  mtyears=[];
  languageConfiguration: any;
  textDir:any;

  gradeSelectConfig = {
    placeholder: 'All grades',
    displayKey: 'name',
    search: false,
    limitTo: 12,
    customComparator: ((a, b) => {
      const nameA = a.year.number; // ignore upper and lowercase
      const nameB = b.year.number; // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    })
  };
  dgradeSelectConfig = {
    placeholder: 'All grades',
    displayKey: 'name',
    search: false,
    limitTo: 12
  };
  dclassSelectConfig = {
    placeholder: 'All classes',
    displayKey: 'name',
    search: false,
    limitTo: 12
  };
  classSelectConfig = {
    placeholder: 'All classes',
    displayKey: 'name',
    search: false,
    limitTo: 12,
    customComparator: ((a, b) => {
      const nameA = a.year.number; // ignore upper and lowercase
      const nameB = b.year.number; // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    })
  };
  yearSelectConfig = {
    placeholder: 'All years',
    displayKey: 'name',
    search: false,
    limitTo: 12,
    customComparator: ((a, b) => {
      const nameA = a.number; // ignore upper and lowercase
      const nameB = b.number; // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      // names must be equal
      return 0;
    })
  };
  subjectSelectConfig = {
    placeholder: 'All subjects',
    placeholderColor: '#c8c8c8',
    displayKey: 'name',
    search: false,
    height: '250px',
    customComparator: ((a, b) => {
      const nameA = a.name.toUpperCase(); // ignore upper and lowercase
      const nameB = b.name.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    })
  };
  languageSelectConfig = {
    placeholder: 'All languages',
    displayKey: 'custom',
    search: false,
    customComparator: ((a, b) => {
      const nameA = a.name.toUpperCase(); // ignore upper and lowercase
      const nameB = b.name.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    })
  };
  sourceSelectConfig = {
    placeholder: 'All sources',
    displayKey: 'name',
    search: false,
    customComparator: ((a, b) => {
      const nameA = a.name.toUpperCase(); // ignore upper and lowercase
      const nameB = b.name.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    })
  };
  typeSelectConfig = {
    placeholder: 'All types',
    displayKey: 'name',
    search: false,
    customComparator: ((a, b) => {
      const nameA = a.name.toUpperCase(); // ignore upper and lowercase
      const nameB = b.name.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    })
  };
  firstTimeLoad = true;

  constructor(
    private router: Router,
    public translate: TranslateService,
    private route: ActivatedRoute,
    private http: HttpClient,
    private contentmangamentService: ContentmanagementService,
    private util: ToolsService
  ) {
      this.languageConfiguration = (languageConfig as any).default;
      translate.addLangs([this.languageConfiguration.languages]);
      translate.setDefaultLang(this.languageConfiguration.defaultLang);
      let selectedLang = sessionStorage.getItem('selectedLang');
      this.textDir =  sessionStorage.getItem('textDir');
      let langRegExp = new RegExp(this.languageConfiguration.languageRegexp);
      if(selectedLang){
        translate.use(selectedLang.match(langRegExp) ? selectedLang : this.languageConfiguration.defaultLang);  
      } else {
        const browserLang = translate.getBrowserLang();                  
        translate.use(browserLang.match(langRegExp) ? browserLang : this.languageConfiguration.defaultLang);  
      }  
      this.highLightRow = 0;
      this.filterCreteria = new FilterCriteria();
      this.afilterCreteria = new FilterCriteria();
      this.ffilterCreteria =new FilterCriteria();
      this.mfilterCreteria = new FilterCriteria();
      this.dfilterCreteria = new FilterCriteria();
      this.contentDetails = new ContentData();
      this.addNewContentModel = new AddContent();
  }

  ngOnInit(): void {
    this.environment = environment;
    this.allowedTypesArr = [
      'application/pdf',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel',
      'audio/mp3',
      'audio/3gpp',
      'audio/3gpp2',
      'audio/3gp2',
      'audio/aac',
      'audio/mpeg',
      'audio/flac',
      'audio/x-flac',
      'audio/mp4',
      'audio/ogg',
      'audio/wave',
      'audio/wav',
      'audio/x-wav',
      'audio/x-pn-wav',
      'audio/webm',
      'video/3gpp',
      'video/3gpp2',
      'video/3gp2',
      'video/mpeg',
      'video/mp4',
      'video/ogg',
      'video/webm'
    ];
    
    this.translate.get('All grades').subscribe((translated: string) => {
      this.gradeSelectConfig = {
        placeholder: translated,
        displayKey: 'name',
        search: false,
        limitTo: 12,
        
        customComparator: ((a, b) => {
          const nameA = a.year.number; // ignore upper and lowercase
          const nameB = b.year.number; // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        })
      };
      this.dgradeSelectConfig = {
        placeholder: this.translate.instant('All grades'),
        displayKey: 'name',
        search: false,
        limitTo: 12
      };
      this.dclassSelectConfig = {
        placeholder: this.translate.instant('All classes'),
        displayKey: 'name',
        search: false,
        limitTo: 12
      };
      this.classSelectConfig = {
        placeholder: this.translate.instant('All classes'),
        displayKey: 'name',
        search: false,
        limitTo: 12,
       
        customComparator: ((a, b) => {
          const nameA = a.year.number; // ignore upper and lowercase
          const nameB = b.year.number; // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        })
      };
      this.yearSelectConfig = {
        placeholder: this.translate.instant('All years'),
        displayKey: 'name',
        search: false,
        limitTo: 12,
        
        customComparator: ((a, b) => {
          const nameA = a.number; // ignore upper and lowercase
          const nameB = b.number; // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          // names must be equal
          return 0;
        })
      };
      this.subjectSelectConfig = {
        placeholder: this.translate.instant('All subjects'),
        placeholderColor: '#c8c8c8',
        displayKey: 'name',
        search: false,
        height: '250px',
        customComparator: ((a, b) => {
          const nameA = a.name.toUpperCase(); // ignore upper and lowercase
          const nameB = b.name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
    
          // names must be equal
          return 0;
        })
      };
      this.languageSelectConfig = {
        placeholder: this.translate.instant('All languages'),
        displayKey: 'custom',
        search: false,
        customComparator: ((a, b) => {
          const nameA = a.name.toUpperCase(); // ignore upper and lowercase
          const nameB = b.name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
    
          // names must be equal
          return 0;
        })
      };
      this.sourceSelectConfig = {
        placeholder: this.translate.instant('All sources'),
        displayKey: 'name',
        search: false,
        customComparator: ((a, b) => {
          const nameA = a.name.toUpperCase(); // ignore upper and lowercase
          const nameB = b.name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
    
          // names must be equal
          return 0;
        })
      };
      this.typeSelectConfig = {
        placeholder: this.translate.instant('All types'),
        displayKey: 'name',
        search: false,
        customComparator: ((a, b) => {
          const nameA = a.name.toUpperCase(); // ignore upper and lowercase
          const nameB = b.name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
    
          // names must be equal
          return 0;
        })
      };
      this.listBySelectConfig = {
        placeholder: this.translate.instant('List by'),
        displayKey: 'name',
        search: false,
        limitTo: 12,
      };
    });
    this.firstTime = true;
    this.distributeContentToClass = new DistributeClassContent();
    this.distributeContentToGroup = new DistributeGroupContent();
    const userData = JSON.parse(window.localStorage.getItem('loginInfoObj'));
    this.loggedInUser = userData;

    if (localStorage.getItem('token')) {
      const userData = JSON.parse(window.localStorage.getItem('loginInfoObj'));
      this.userDetails = userData;
      if (userData.project) {
        this.project_id = userData.project._id;
      }
      if (localStorage.getItem('curriculumData')) {
        this._curriculumData = JSON.parse(localStorage.getItem('curriculumData'));
        if (this._curriculumData.subject_id) {
          this.filterCreteria.subjectId = this._curriculumData.subject_id;
        }
      }
      
      
      this.loadData().then( () => {
        this.loaded = true;
      });
    } else {
      this.router.navigate(['/login']);
    }
    this.isGroupTab = false;
    this.isClassTab = true;
  }

  ngAfterViewInit() {
    this.tabInit();
    // this.dropdownInit();
  }

  loadData(){
    return new Promise<void>((resolve, reject) => {
      forkJoin({
        yearInfo: this.getYearData(),
        mediaTypeInfo: this.getMediaTypeData(),
        contentListInfo: this.getContentlistData(),
        soursesInfo: this.getSourcesData(),
        subjectInfo: this.getSubjectData(),
        projectListInfo: this.getProjectList(),
        languageInfo: this.getLanguageData()
      });
      // loadDataItem.subscribe(val => console.log(val))
      if (this.project_id) {
        this.getGradeData();
      }
      if (this.loggedInUser.role.name === 'Teacher') {
        this.getClassRoomList();        
      }
      this.teacherdistributeList = new Array<ContentData>();
      this.teachercontentList = new Array<ContentData>();
      this.getmyDistributedMaterialListData();
      this.getmyContentMaterialListData();
      resolve();
    });
  }

  getRejectedStatus(status){
    if (status){
      this.fileFormat = false;
    }else{
      this.fileFormat = true;
    }
  }

  tabInit(){
    const tabs = document.querySelectorAll('.tabs');
    if (tabs) {
      Array.from(tabs).forEach(tabGroup1 => {
        const tabGroup = new TabGroup(tabGroup1 as HTMLElement);
        tabGroup.init();
      });
    }
  }
  // dropdownInit(){
  //   const dropDwn = new Dropdown(this.classgroupDropdown.nativeElement);
  //   dropDwn.init();
  //   const dropDownMenu = new Menu(this.classgroupMenu.nativeElement);
  //   dropDownMenu.show();

  // }
  getFileType(type){
    const fileType = [];
    fileType['document'] = ['application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel'];

    fileType['audio'] = [
      'audio/mp3',
      'audio/3gpp',
      'audio/3gpp2',
      'audio/3gp2',
      'audio/aac',
      'audio/mpeg',
      'audio/flac',
      'audio/x-flac',
      'audio/mp4',
      'audio/ogg',
      'audio/wave',
      'audio/wav',
      'audio/x-wav',
      'audio/x-pn-wav',
      'audio/webm'
    ];

    fileType['video'] = [
      'video/3gpp',
      'video/3gpp2',
      'video/3gp2',
      'video/mpeg',
      'video/mp4',
      'video/ogg',
      'video/webm'
    ];

    if (fileType['document'].findIndex(x => x === type) !== -1){
      this.addNewContentModel.media_type = 'document';
    }
    if (fileType['audio'].findIndex(x => x === type) !== -1){
      this.addNewContentModel.media_type = 'audio';
    }
    if (fileType['video'].findIndex(x => x === type) !== -1){
      this.addNewContentModel.media_type = 'video';
    }
  }

  getmyContentMaterialListData() {
    this.msubjects = [];
    this.contentmangamentService.getMyCreatedListData().subscribe(
      (response) => {
        this.mycontentList = this.teachercontentList = response;
        // const mtempSubArr = [];
        const mtempSourceArr = [];
        const mtempType = [];
        const mtempLangArr = [];
        const mTempYearArr = [];
        // const mTempGradeArr = [];
        const myAvailableYears = [];
        const myAvailableGrades = [];
        for (let i = 0; i < this.teachercontentList.length; i++){
          if(this.teachercontentList[i].subject) {
            this.msubjects.push(this.teachercontentList[i].subject);
          }
          if (this.loggedInUser.role.name === 'GeneralAdmin'){
            if (this.data){
              mTempYearArr.push(this.data[i].start_year);
              mTempYearArr.push(this.data[i].end_year);
              for(let kk=this.teachercontentList[i].start_year.number; kk <= this.teachercontentList[i].end_year.number; kk++){
                if(myAvailableYears.length > 0){
                  if (myAvailableYears.findIndex(x => x._id === this.yearsDD[kk-1]._id) === -1){
                    myAvailableYears.push(this.yearsDD[kk-1]);
                  }
                }else{
                  myAvailableYears.push(this.yearsDD[kk-1]);
                }        
              }
            }
          }
          else{
            for(let kk=this.teachercontentList[i].start_grade.year.number; kk <= this.teachercontentList[i].end_grade.year.number; kk++){
              if(myAvailableGrades.length > 0){
                if (this.gradesDD.length > (kk-1) && myAvailableGrades.findIndex(x => x._id === this.gradesDD[kk-1]._id) === -1){
                  if(this.gradesDD[kk-1]){
                    myAvailableGrades.push(this.gradesDD[kk-1]);
                  }
                }
              }else{
                if(this.gradesDD.length > (kk-1) && this.gradesDD[kk-1]){
                  myAvailableGrades.push(this.gradesDD[kk-1]);
                }
              }        
            }
          }
          
          mtempLangArr.push(this.teachercontentList[i].language);
          mtempSourceArr.push(this.teachercontentList[i].source);
          if (this.types){
            const mtempR = this.types.filter( type=> this.teachercontentList[i].media_type==type.name.toLowerCase());
            mtempType.push(mtempR[0]);
          }
        }       
        this.mlanguages = mtempLangArr;
        for (const mlanguage of this.mlanguages) {
          mlanguage['custom'] = mlanguage.name.charAt(0).toUpperCase() + mlanguage.name.slice(1);
        }
        if(this.contentList && this.contentList.length && this.loggedInUser.role.name === 'GeneralAdmin'){
          this.mYears = myAvailableYears;
        } else {
          this.mgrades = myAvailableGrades;
        }          
        if(this.teachercontentList.length && this.loggedInUser.role.name === 'GeneralAdmin'){
          this.yearsDD = this.yearsDD.sort(this.GetSortOrder('number'));
          this.mYears = myAvailableYears;
          console.log(this.mYears);
        }
        this.msources = mtempSourceArr;
        this.mtypes = mtempType;
      },
      (err) => {
        this.showLoader = false;
        const errorHandlerObj = new MyErrorHandler();
        this.errorHandler = errorHandlerObj.handleError(err);
        if (this.errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        // console.log(this.msubjects);
        setTimeout(() => { this.tabInit(); }, 300);
      }
    );
  }

  isItemSelected(id){
    const idx = this.classList.indexOf(id);
    if (idx === -1) {
      return false;
    } else {
      return true;
    }
  }

  getmyDistributedMaterialListData() {
    if (this.loggedInUser.role.name === 'Teacher'){
    this.contentmangamentService.getDestributedMaterialListData().subscribe(
      (response) => {
        const tmpGrade = [];
        const tmpClass = [];
        this.distContentList = this.teacherdistributeList = response;
        this.teacherdistributeList.forEach(element => {
          if (element.classes && element.classes.length) {
            element.classes.forEach(cl => {
              const l = tmpClass.filter(x => x.name === cl.name && x.grade.name === cl.grade.name);
              if (!l.length) {
                tmpClass.push(cl);
              }
              const m = tmpGrade.filter(x => x.name === cl.grade.name);
              if (!m.length) {
                tmpGrade.push(cl.grade);
              }
            });
          } else if (element.groups && element.groups.length) {
            element.groups.forEach(gp => {
              const l = tmpClass.filter(x => x.name === gp.class.name && x.grade.name === gp.class.grade.name);
              if (!l.length) {
                tmpClass.push(gp.class);
              }
              const m = tmpGrade.filter(x => x.name === gp.class.grade.name);
              if (!m.length) {
                tmpGrade.push(gp.class.grade);
              }
            });
          }
        });
        this.distributeGradeFilterList = [...tmpGrade];
        //console.log("this.distributeGradeFilterList--"+JSON.stringify( this.distributeGradeFilterList));
        this.distributeClassFilterList = [...tmpClass];
        //console.log("this.distributeClassFilterList--"+JSON.stringify( this.distributeClassFilterList));
      },
      (err) => {
        this.showLoader = false;
        const errorHandlerObj = new MyErrorHandler();
        this.errorHandler = errorHandlerObj.handleError(err);
        if (this.errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
      // console.log("COMPLETED");
      }
    );
  }
  }

  createMultiSelectPorjectList() {
     this.getProjectList();
  }

  updateSelectedProjects(option,event){
    this.selectedProjectsMap[option._id] = event.target.checked;
    console.log(this.selectedProjectsMap);
  }
 resetDropdown(){
  //alert("reset dropdown")
  this.afilterCreteria.subject_id = null;
 /*  this.ffilterCreteria =  new FilterCriteria();
  this.dfilterCreteria = new FilterCriteria();
  this.mfilterCreteria =  new FilterCriteria(); */

 }
  getContentlistData() {
    this.showLoader = true;
    this.contentmangamentService.getContentlist().subscribe(
      (response) => {
        this.showLoader = false;
        this.data = this.projectContent = response;

        this.ftempSubArr = [];
        this.ftempLangArr = [];
        this.ftempSourceArr = [];
        this.ftempType = [];
        this.ftempYears = [];
        this.fTempGradeArr = [];
        for ( let i = 0; i < this.data.length; i++){
          if (this.data[i].favorite === true){
            if (this.loggedInUser.role.name === 'GeneralAdmin'){
              this.ftempYears.push(this.data[i].start_year);
              this.ftempYears.push(this.data[i].end_year);
            }
            else{  
              this.fTempGradeArr.push(this.data[i].start_grade);
              this.fTempGradeArr.push(this.data[i].end_grade);
            }
            if(this.data[i].subject){
              this.ftempSubArr.push(this.data[i].subject);
            }            
            this.ftempLangArr.push(this.data[i].language);
            this.ftempSourceArr.push(this.data[i].source);
            if (this.types){
              const result = this.types.filter( type => this.data[i].media_type === type.name.toLowerCase());
              this.ftempType.push(result[0]);
            }
          }
        }
       
        this.fsubject = this.ftempSubArr;
        this.flanguages = this.ftempLangArr;
        this.fsource = this.ftempSourceArr;
        this.ftype = this.ftempType;
        this.fYears = this.ftempYears;
        this.fgrades = this.fTempGradeArr;
        

        if (this.projectContent[0]) {
          this.getFilterData();
        }
      },
      (err) => {
        this.showLoader = false;
        const errorHandlerObj = new MyErrorHandler();
        this.errorHandler = errorHandlerObj.handleError(err);
        if (this.errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
       // console.log("COMPLETED");
      }
    );
  }

  /***
   * this method will be used to get the specific project content details based on project id
   */
  getProjectContentlistData(projectId) {
    this.showLoader = true;
    this.isContentFound = false;
    this.contentmangamentService.getProjectContentList(projectId).subscribe(
      (response) => {
        if (response != null && response.length > 0) {
          this.isContentFound = false;
          this.data = this.projectContent = response;
          if (this.projectContent) {
            this.getFilterData();
          }
        }
        this.showLoader = false;
      },
      (err) => {
        console.log('ERROR: ' + err);
        this.showLoader = false;
        const errorHandlerObj = new MyErrorHandler();
        this.errorHandler = errorHandlerObj.handleError(err);
        if (this.errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        this.showLoader = false;
        console.log('COMPLETED');
      }
    );
  }

  /***
   * this method will be used to get all sources data
   */
  getSourcesData() {
    this.contentmangamentService.getSources().subscribe(
      (response) => {
        this.sourcesDD = response;
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        this.errorHandler = errorHandlerObj.handleError(err);
        if (this.errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        // console.log('COMPLETED');
      }
    );
  }

  /***
   * this method will be used to get topic details based on subject id
   */
  getTopicData() {
     this.contentmangamentService.getTopics(this.addNewContentModel.subject_id).subscribe(
       (response) => {
         this.topics = response;
       },
       (err) => {
        const errorHandlerObj = new MyErrorHandler();
        this.errorHandler = errorHandlerObj.handleError(err);
        if (this.errorHandler.isSssionExpired) {
           this.router.navigate(['/login']);
           return true;
         }
       },
       () => {
        // console.log("COMPLETED");
       }
     );
   }

   /***
    * this method will be used to get language details
    */
  getLanguageData() {
    this.contentmangamentService.getLanguage().subscribe(
      (response) => {
        this.allLanguages = response;
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        this.errorHandler = errorHandlerObj.handleError(err);
        if (this.errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {

       // console.log("COMPLETED");
      }
    );
  }

  /***
    * this method will be used to get subject details
    */
   getSubjectData() {
    if (this.project_id) {
      this.contentmangamentService.getProjectSubject(this.project_id).subscribe(
        (response) => {
          this.subjectsDD = response;
        },
        (err) => {
          const errorHandlerObj = new MyErrorHandler();
          this.errorHandler = errorHandlerObj.handleError(err);
          if (this.errorHandler.isSssionExpired) {
            this.router.navigate(['/login']);
            return true;
          }
        },
        () => {
          // console.log('COMPLETED');
        }
      );
    } else {
      this.contentmangamentService.getSubject().subscribe(
        (response) => {
          this.subjectsDD = response;
        },
        (err) => {
          const errorHandlerObj = new MyErrorHandler();
          this.errorHandler = errorHandlerObj.handleError(err);
          if (this.errorHandler.isSssionExpired) {
            this.router.navigate(['/login']);
            return true;
          }
        },
        () => {
          console.log('COMPLETED');
        }
      );
    }
  }

   /***
   * this method will be used to get Teacher classroom List
 */
  getClassRoomList() {
    this.showLoader = true;
    return new Promise<void>((resolve, reject) => {
      this.contentmangamentService.getClassRoomListData().subscribe(
        (response) => {
          if (response != null && response.length > 0) {
            this.classRoomList = [...response];
            this._classId = this.classRoomList[0]._id;
            this.invokeGroupListService(this._classId);
          }
          this.showLoader = false;
          resolve();
        },
        (err) => {
          const errorHandlerObj = new MyErrorHandler();
          this.errorHandler = errorHandlerObj.handleError(err);
          if (this.errorHandler.isSssionExpired) {
            this.router.navigate(['/login']);
            return true;
          }
          this.showErrorBox();
          reject();
        },
      );
    });
  }

  setDistributeTab(tab) {
    if (tab === 'class') {
      this.isClassTab = true;
      this.isGroupTab = false;
    } else if (tab === 'group') {
      this.isClassTab = false;
      this.isGroupTab = true;
    }
  }

  invokeGroupListService(classId) {
    this.groupListData = null;
    return this.contentmangamentService.getClassGroupListData(classId).subscribe(
      (response) => {
        if (response != null && response.length > 0) {
          this.groupListData = [...response];
          response.forEach(group => {
            this.setDistributionValues(null, group._id);
          });
          return;
        }
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        this.errorHandler = errorHandlerObj.handleError(err);
        if (this.errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
        this.showErrorBox();
      },
      () => {
        // console.log('COMPLETED');
      }
    );
  }

  getClassData(classId) {
    this._classId = classId;
    // this.validationMsg = "";
    this.invokeGroupListService(this._classId);
  }
  SelectAll(ev) {
    this.firstTimeLoad = false;
    if (ev.target.checked) {
      this.isAllSelected = true;
      this.isAllDeSelected = false;
      this.classList = new Array();

      for (const value of this.classRoomList) {
        const idx = this.classList.indexOf(value._id);
        if (idx === -1) {
          this.classList.push(value._id);
        }
      }
      if (this.classRoomList != null && this.classRoomList.length > 0) {
        for (let i = 0; i < this.classRoomList.length; i++) {
          this.classRoomList[i].isExit = true;
        }
      }
    }else{
      this.DeSelectAll();
    }
    if(this.classList.length>0){
      this.disableDistribute = false;
    }else{
      this.disableDistribute = true;
    }
  }

  DeSelectAll() {
    this.firstTimeLoad = false;
    this.isAllSelected = false;
    this.isAllDeSelected = false;
    this.classList = new Array();
    this.groupList = new Array();
    if (this.classRoomList != null && this.classRoomList.length > 0) {
      for (let i = 0; i < this.classRoomList.length; i++) {
        this.classRoomList[i].isExit = false;
      }
    }
  }

  updateCancel(){
    this.firstTimeLoad = true;
    this.isAllSelected = false;
  }

  invokeDistributeContent() {
    this.isUpdate = false;
    if (this.isClassTab) {
      /* This conditions are added as class and group both can be updated same time regradless 
      * which tab the user is in 
      */

      this.distributeContentToClass.classes = this.classList;
      this.invokeDistributeContentService(this.distributeContentToClass).then(()=>{
        this.classList = new Array();
      });

      this.distributeContentToGroup.groups = this.groupList;
      this.invokeDistributeContentService(this.distributeContentToGroup).then(()=>{
        this.groupList = new Array();
      });
      
      this.closeDialogModal('distributeContentModel');
      this.titleMessage = this.translate.instant('Distribution')+" "+ this.translate.instant('updated');
      this.subTitleMessage = this.contentDetails.title;
      // this.detailMessage = 'You can verify your content distribution in My Distribution';
      this.detailMessage = '';
      this.openDialogModal('successModal');
    } else if (this.isGroupTab) {
      /* This conditions are added as class and group both can be updated same time regradless 
      * which tab the user is in 
      */
      this.distributeContentToClass.classes = this.classList;
      this.invokeDistributeContentService(this.distributeContentToClass).then(()=>{
        this.classList = new Array();
      });

      this.distributeContentToGroup.groups = this.groupList;
      this.invokeDistributeContentService(this.distributeContentToGroup).then(()=>{
        this.groupList = new Array();
      });
      
      this.closeDialogModal('distributeContentModel');
      this.groupListData = null;
      this.titleMessage = this.translate.instant('Distribution')+" "+ this.translate.instant('updated');
      this.subTitleMessage = this.contentDetails.title;
      // this.detailMessage = 'You can verify your content distribution in My Distribution';
      this.detailMessage = '';
      this.openDialogModal('successModal');
    }
    this.firstTimeLoad = true;
    this.isAllSelected = false;
  }

  /***
  * this method will be used to get topic details based on subject id
  */
  invokeDistributeContentService(data) {
    return new Promise<void>((resolve, reject) => {
      this.contentmangamentService.distributeContentService(data, this.contentId).subscribe(
        (response) => {
          
        }, (err) => {
          const errorHandlerObj = new MyErrorHandler();
          this.errorHandler = errorHandlerObj.handleError(err);
          if (this.errorHandler.isSssionExpired) {
            this.router.navigate(['/login']);
            return true;
          }
          this.showErrorBox();
          reject();
        },
        () => {
          this.getmyDistributedMaterialListData();
          console.log('COMPLETED');
          resolve();
        }
      );
    });
  }

  /***
   * this method will be used to get year details
   */
  getYearData() {
    this.contentmangamentService.getYear().subscribe(
      (response) => {
        this.yearsDD = response;
        this.yearsDD = this.yearsDD.sort(this.GetSortOrder('number'));
       //console.log("yearsDD--"+JSON.stringify(this.yearsDD));
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        this.errorHandler = errorHandlerObj.handleError(err);
        if (this.errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {

        //console.log("COMPLETED");
      }
    );
  }

  /***
   * this method will be used to get grade details
   */
  getGradeData() {
    this.contentmangamentService.getProjectGrade(this.project_id).subscribe(
      (response) => {
        this.gradesDD1 = response;        
        for(var i=0; i<this.gradesDD1.length; i++ ){
          let grade =  this.gradesDD1[i];
          if(this.gradesDD1[i].year){
            grade.number =  this.gradesDD1[i].year.number;
          }          
          this.gradesDD.push(grade);
        }
        this.gradesDD= this.gradesDD.sort(this.GetSortOrder('number')); 
       // console.log("---this.gradesDD---"+JSON.stringify(this.gradesDD));
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        this.errorHandler = errorHandlerObj.handleError(err);
        if (this.errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {

       // console.log("COMPLETED");
      }
    );
  }

  /**
   * lookup grade name from year
   */
  lookupGradeName(year) {
    const grade = this.grades.filter(x => x.year._id === year._id);
    if (grade && grade.length) {
      return grade[0].name;
    } else {
      return year.name;
    }
  }

  gradeFromYearID(year_id) {
    const grade = this.grades.filter(x => x.year._id === year_id);
    if (grade && grade.length) {
      return grade[0].name;
    }
    return '';
  }

  /***
   * this method will be used to get mediaType details
   */
  getMediaTypeData() {
    this.contentmangamentService.getMediaType().subscribe(
      (response) => {
        this.types = response;
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        this.errorHandler = errorHandlerObj.handleError(err);
        if (this.errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {

      //  console.log("COMPLETED");
      }
    );
  }

  /***
   * this method will be used to get project list
   */
  getProjectList() {
    this.contentmangamentService.getProjects().subscribe(
      (response) => {
        this.projects = response;
      }, (err) => {
        const errorHandlerObj = new MyErrorHandler();
        this.errorHandler = errorHandlerObj.handleError(err);
        if (this.errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {

      //  console.log("COMPLETED");
      }
    );
  }

  /***
   * this method will be used to get project details based on projectId
   */

  getProjectData(projectId) {
    this.contentList = new Array<ContentData>();
    if (projectId === 0) {
      this.getContentlistData();
    } else {
      this.getProjectContentlistData(projectId);
    }
  }

  /***
    * this method will be used to get content details
   */
  contentdetails(item) {
    this.cmviewType = 'read';
    this.contentDetails = new Topicdetails();
    this.contentDetails = item;
    this.contentId = item._id;
    this.classId = null;
    this.groupListData = null;
    this.btnTextCancel = 'Close';
    this.openDialogModal('viewContentModel');
  }

  cancelEditContent(){
    this.closeDialogModal('viewContentModel');
  }

  /***
  * this method will be used to get the updated content details
  */
  refreshContentPageData() {
    this.deleted = false;
    this.getmyContentMaterialListData();
    this.getContentlistData();
    const userData = JSON.parse(window.localStorage.getItem('loginInfoObj'));
    // if (userData.role.name === 'Teacher') {
    //   this.getmyDistributedMaterialListData();
    // }
  }

  /* Reset the content modal window when clicked cancel button */
  resetContentModal(){
    this.fileFormat = true;
  }

  /***
   * this method will be used to create content and check for validations
   */
  createContent() {
    this.addNewContentModelSubmit = {...this.addNewContentModel};
    this.detailMessage1 = '';
    this.detailMessage2 = '';
    let tags = [];
    if (this.tagsString) {
      tags = this.tagsString.split(',');
    }

    // this.tagsString = null;
    if (tags) {
      this.addNewContentModel.tags = tags;
      this.addNewContentModelSubmit.tags = tags;
    } else {
      this.addNewContentModel.tags = [];
      this.addNewContentModelSubmit.tags = [];
    }
    //console.log('addNewContentModel status', this.addNewContentModel.status);
    if (this.addNewContentModel.status === '1') {

      var _project = new PublishTo();
      // var ids = new Array<string>();
      // if (this.selectedItems.length <= 0) {
      //   return this.projectValidation = "Select atleast one project";
      // }

      // this.addNewContentModel.status = "Published";
      // for (var index = 0; index < this.selectedItems.length; index++) {
      //   console.log("Multi JSON", JSON.stringify(this.selectedItems[index].id));
      //   ids.push(this.selectedItems[index].id);
      // }
      // _project.projects = ids;
      this.addNewContentModelSubmit.status = 'Unpublished';
      this.addNewContentModel.published_to = _project;
    } else if (this.addNewContentModel.status === '2') {
      let _project = new PublishTo();

      /* Check user role and based on role publishing status will be different  */
      if (this.userDetails.role.name === 'SchoolAdmin'){
        _project.school = true;
      }else if (this.userDetails.role.name === 'ProjectAdmin' || this.userDetails.role.name == 'ContentProvider'){
        let projectArr = [];
        projectArr = [this.userDetails.project._id];
        _project.projects = projectArr;
      }else if (this.userDetails.role.name === 'GeneralAdmin'){
        _project.all = true;
      }
      this.addNewContentModelSubmit.status = 'Published';
      this.addNewContentModel.published_to = _project;
      this.addNewContentModelSubmit.published_to = _project;
    } else if (this.addNewContentModel.status === '3') {
      let _project = new PublishTo();
      if (this.userDetails.role.name === 'ContentProvider'){
        _project.all = true;
        this.addNewContentModelSubmit.status = 'Unpublished';
      }else if (this.userDetails.role.name === 'Teacher'){
        _project.self = true;
        this.addNewContentModelSubmit.status = 'Published';
      }else{
        _project.all = true;
        this.addNewContentModelSubmit.status = 'Published';
      }
      this.addNewContentModel.published_to = _project;
      this.addNewContentModelSubmit.published_to = _project;
    }else if (this.addNewContentModel.status === '4') {
      let _project = new PublishTo();
      for (const x in this.selectedProjectsMap) {
        if (this.selectedProjectsMap[x]) {
            this.selectedProjectsChecked.push(x);
        }
      }
      this.selectedProjects = this.selectedProjectsChecked;
      _project.projects = this.selectedProjects;
      this.selectedProjectsChecked = [];
      this.addNewContentModel.published_to = _project;
      this.addNewContentModelSubmit.status = 'Published';
    }

    if (this.addNewContentModel.media) {
      this.addNewContentModel.media_id = this.addNewContentModel.media._id;
      this.addNewContentModel.media_url = this.addNewContentModel.media.url;
      this.addNewContentModel.media_type = this.addNewContentModel.media.type;
      this.addNewContentModelSubmit.media_id = this.addNewContentModel.media._id;
      this.addNewContentModelSubmit.media_url = this.addNewContentModel.media.url;
      this.addNewContentModelSubmit.media_type = this.addNewContentModel.media.type;
      console.log('media type', this.addNewContentModel.media_type)
      if (this.addNewContentModel.media_type === 'text' || this.addNewContentModel.media_type === 'application') {
        this.addNewContentModel.media_type = 'document';
        this.addNewContentModelSubmit.media_type = 'document';
      }
      const mime_type = this.addNewContentModel.media.name.split('.');
      this.addNewContentModel.media_mime_type = mime_type[mime_type.length - 1];
      this.addNewContentModel.media_name = this.addNewContentModel.media.name;
      this.addNewContentModelSubmit.media_mime_type = mime_type[mime_type.length - 1];
      this.addNewContentModelSubmit.media_name = this.addNewContentModel.media.name;
    }

    this.contentmangamentService.createNewContent(this.addNewContentModelSubmit).subscribe(
      (response) => {
        this.showFileUploadLoader = false;
        console.log('Return createNewContent response from CTL:', response);
        this.message = response.message;
        this.closeDialogModal('addContentModel');
        if (this._curriculumData && this._curriculumData.subject_id) {
          this.addContentToUint(response.content_id);
        } else {
          this.contentDetails = this.addNewContentModelSubmit;
          this.titleMessage = this.translate.instant('New')+" "+ this.translate.instant('Content')+" "+this.translate.instant('added');
          this.subTitleMessage =  this.contentDetails.title;
          if (this.userDetails.role.name === 'Teacher'){
            this.detailMessage = this.translate.instant('To share with your School place a request with your School Administrator.');
          }
          if (this.userDetails.role.name === 'ContentProvider'){
            this.detailMessage = this.translate.instant('To share with other Project or all Projects, place a request with Global Administrator.');
          }
         
          this.detailMessage1 = '';
          this.detailMessage2 = '';
          this.openDialogModal('successModal');
        }
      },
      (err) => {
        this.showFileUploadLoader = false;
        const errorHandlerObj = new MyErrorHandler();
        this.errorHandler = errorHandlerObj.handleError(err);
        const jsonBody = err.detail;
        const errorDetails = err.error.detail;
        // alert("error="+JSON.stringify(errorDetails));
        console.log(this.errorHandler);
        let msg = '';
        for (const key of Object.keys(errorDetails)) {
          const errorInfo = errorDetails[key][0];
          let errorInfoMessage = '';
          console.log(errorInfo);
          if (errorInfo === 'title cannot be empty, max allowed length is 50 characters'){
            errorInfoMessage = this.translate.instant('Title cannot be empty, max allowed length is 50 characters');
          }else if (errorInfo === 'Provide supported media only[Image, Audio, Video, Application, Document, Link]'){
            errorInfoMessage = this.translate.instant('Use valid content type');
          }else if (errorInfo === 'use valid subject_id'){
            errorInfoMessage = this.translate.instant('Use valid subject');
          }
          if (errorInfo === 'use valid start_year_id'){
            errorInfoMessage = this.translate.instant('Use valid start year');
          }

          if (errorInfo === 'use valid end_year_id'){
            errorInfoMessage = this.translate.instant('Use valid end year');
          }

          if (errorInfo === 'use valid source_id'){
            errorInfoMessage = this.translate.instant('Use valid source');
          }

          if (errorInfo === 'use valid language_id'){
            errorInfoMessage = this.translate.instant('Use valid language');
          }
          if (errorInfo == 'use valid published to project list'){
              errorInfoMessage = this.translate.instant('Use valid publish to project list');
          }
         if (errorInfo == 'use valid published to school list'){
          errorInfoMessage = this.translate.instant('Use valid publish to school list');
          }
         if (errorInfo == 'use valid published to list'){
          errorInfoMessage = this.translate.instant('Use valid publish to list');
          }

          if (Array.isArray(errorInfo)){
            if (errorInfo[0].value === 'too big'){
              errorInfoMessage = this.translate.instant('tag is too big.');
            }
          }
          msg += '<li>' + errorInfoMessage + '</li>';
        }
        if(msg !== ''){
          msg = '<ul class="content-error-msg">'+msg+'</ul>';
        }
        this.titleMessage = this.translate.instant('Upload')+" "+ this.translate.instant('New')+" "+this.translate.instant('Content');
        this.detailMessage1 = this.translate.instant('There is an error or missing information. Please check if all details are entered correctly.');
        this.detailMessage2 = msg;
        this.openDialogModal('errorModal');
        if (this.errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        console.log('COMPLETED');
        this.refreshContentPageData();
      }
    );

  }

  mouseHover() {
    // jQuery("#contenttooltip.tooltip.right").css("display","block")
  }

  mouseout(){
    // jQuery("#contenttooltip.tooltip.right").css("display","none");
  }


  /***
    * this method will be invoked on submit button click event and
    * in this method if ther is any change in asset then we will call msdp update api to update the asset data
    * and then we will call ctl update api to update content data
    * otherwise we will call directly ctl update api to update content data
    */

   updateContent() {
    this.addNewContentModelSubmit = {...this.addNewContentModel};
    this.detailMessage1 = '';
    this.detailMessage2 = '';
    this.addNewContentModel.published_to = null;
    let tags = new Array<string>();
    if (this.tagsString) {
      tags = this.tagsString.split(',');
    }
    if (tags != null && tags.length > 0) {
      this.addNewContentModel.tags = tags;
      this.addNewContentModelSubmit.tags=tags;
    } else {
      this.addNewContentModel.tags = [];
    }
    if (this.addNewContentModel.status === '1') {
      let _project = new PublishTo();
      if (this.userDetails.role.name === 'ProjectAdmin' || this.userDetails.role.name === 'ContentProvider'){
        let projectArr = [];
        projectArr = [this.userDetails.project._id];
        _project.projects = projectArr;
      } else if (this.userDetails.role.name === 'GeneralAdmin'){
        for (const x in this.selectedProjectsMap) {
          if (this.selectedProjectsMap[x]) {
              this.selectedProjectsChecked.push(x);
          }
        }
        this.selectedProjects = this.selectedProjectsChecked;
        _project.projects = this.selectedProjects;
        this.selectedProjectsChecked = [];
      }
      this.addNewContentModel.published_to = _project;
      this.addNewContentModelSubmit.published_to = _project;
      this.addNewContentModelSubmit.status = 'Published';
    } else if (this.addNewContentModel.status === '2') {
      var _project = new PublishTo();
      if (this.userDetails.role.name === 'SchoolAdmin'){
        _project.school = true;
      }else if (this.userDetails.role.name === 'Teacher'){
        _project.self = true;
      }else if (this.userDetails.role.name === 'GeneralAdmin'){
        _project.all = true;
      }
      this.addNewContentModelSubmit.status = 'Published';
      this.addNewContentModel.published_to = _project;
      this.addNewContentModelSubmit.published_to = _project;
    } else if (this.addNewContentModel.status === '3') {
      var _project = new PublishTo();
      this.addNewContentModelSubmit.status = 'Unpublished';
      this.addNewContentModel.published_to = _project;
      this.addNewContentModelSubmit.published_to = _project;
    }
    if (this.addNewContentModel.media) {
      this.addNewContentModel.media_id = this.addNewContentModel.media._id;
      this.addNewContentModel.media_url = this.addNewContentModel.media.url;
      this.addNewContentModel.media_type = this.addNewContentModel.media.type;
      this.addNewContentModelSubmit.media_id = this.addNewContentModel.media._id;
      this.addNewContentModelSubmit.media_url = this.addNewContentModel.media.url;
      this.addNewContentModelSubmit.media_type = this.addNewContentModel.media.type;
      if (this.addNewContentModel.media_type === 'text' || this.addNewContentModel.media_type === 'application') {
        this.addNewContentModel.media_type = 'document';
        this.addNewContentModelSubmit.media_type = 'document';
      }
      let mime_type = this.addNewContentModel.media.name.split('.');
      this.addNewContentModel.media_mime_type = mime_type[mime_type.length - 1];
      this.addNewContentModel.media_name = this.addNewContentModel.media.name;
      this.addNewContentModelSubmit.media_mime_type = mime_type[mime_type.length - 1];
      this.addNewContentModelSubmit.media_name = this.addNewContentModel.media.name;
    }
   // console.log("Update Content", JSON.stringify(this.addNewContentModel));
    /*
    if (this.isMediaUpdated) {
      this.updateContentDetails();
    } else {
      */
    this.showFileUploadLoader = true;

    this.contentmangamentService.updateContent(this.contentDetails._id, this.addNewContentModelSubmit).subscribe(
      (response) => {
        this.showFileUploadLoader = false;
        this.message = response.message;
        this.closeDialogModal('editContentModel');
        this.contentDetails = this.addNewContentModel;
        this.titleMessage = this.translate.instant('Content')+" "+this.translate.instant('updated');
        this.subTitleMessage = this.contentDetails.title;
        this.detailMessage = '';
        this.openDialogModal('successModal');
        this.refreshContentPageData();
      },
      (err) => {
        this.showFileUploadLoader = false;
        const errorHandlerObj = new MyErrorHandler();
        this.errorHandler = errorHandlerObj.handleError(err);
        const jsonBody = err.detail;
        const errorDetails = err.error.detail;
        let msg = '';
        for (const key of Object.keys(errorDetails)) {
          const errorInfo = errorDetails[key];
          let errorInfoMessage = '';
          console.log("Errors "+errorInfo);
          if (errorInfo == 'title cannot be empty, max allowed length is 50 characters'){
            errorInfoMessage = this.translate.instant('Title cannot be empty, max allowed length is 50 characters');
          }else if (errorInfo == 'Provide supported media only[Image, Audio, Video, Application, Document, Link]'){
            errorInfoMessage = this.translate.instant('Use valid content type');
          }else if (errorInfo == 'use valid subject_id'){
            errorInfoMessage = this.translate.instant('Use valid subject');
          }else if (errorInfo == 'use valid start_year_id'){
            errorInfoMessage = this.translate.instant('Use valid start year');
          }else if (errorInfo == 'use valid end_year_id'){
            errorInfoMessage = this.translate.instant('Use valid end year');
          }else if (errorInfo == 'use valid source_id'){
            errorInfoMessage = this.translate.instant('Use valid source');
          }else if (errorInfo == 'use valid language_id'){
            errorInfoMessage = this.translate.instant('Use valid language');
          }else if (errorInfo == 'description max allowed length is 300 characters'){
            errorInfoMessage = this.translate.instant('Maximum allowed description length is 300 characters');
          }else if (errorInfo == 'use valid published to project list'){
            errorInfoMessage = this.translate.instant('Use valid publish to project list');
        }else if (errorInfo == 'use valid published to school list'){
          errorInfoMessage = this.translate.instant('Use valid publish to school list');
        }
        else if (errorInfo === 'use valid published to list'){
          errorInfoMessage = this.translate.instant('Use valid publish to list');
        }
          msg += '<li>' + errorInfoMessage + '</li>';
        }
        this.titleMessage = this.translate.instant('Edit')+" "+ this.translate.instant('Content');
        this.detailMessage1 = this.translate.instant('There is an error or missing information. Please check if all details are entered correctly.');
        this.detailMessage2 = msg;
        this.openDialogModal('errorModal');
        if (this.errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {

        //console.log("COMPLETED");
      }
    );
      /*
    } */
  }

  distributeContent(){
    this.classList = new Array();
    this.disableDistribute = true;
    this.getClassRoomList().then(()=>{
      if (this.classRoomList != null && this.classRoomList.length > 0) {
        let isAllItemsSelected = true;
        for (const value of this.classRoomList) {
          if(!this.isDistributedToClassGroup(value._id)){
            isAllItemsSelected = false;
            // break;
          } else {            
            const idx = this.classList.indexOf(value._id);
            if (idx === -1) {
              this.classList.push(value._id);
            }
          }
        }
        if(isAllItemsSelected){
          this.isAllSelected = true;
        }
      }
      this.closeDialogModal('viewContentModel');
      this.openDialogModal('distributeContentModel');
    }); 
    
  }

  getMyDistributeContent(){
  }

  /***
   * this method will call msdp create api to create the asset data
   * and then after ctl create api will be invoked to create content data
   */
  createNewContent() {
    var _this = this;
    this.showFileUploadLoader = true;
    var groupId = 'file';
    var _addNewContentModel = this.addNewContentModel;

    // this will hit the msdp createAssets web service and returns the newly created asset id and its details
    getCreateAssetsResponse(
      environment.msdpAPIBaseURL, groupId, this.contentType, this.fileName, this.content, this.fileType, this.fileSize, this.addNewContentModel.title,
      this.addNewContentModel.description, this.addNewContentModel.tags[0], this.selectedLanguage, this.msdpFileType,

      //the callback function is invoked AFTER the response arrives
      function() {
        //to handle the error scenarios
        if (this.status === 500) {
          _this.handleMsdpError(_this);
        }
        // this method will convert xml object to json object
        var asstesResponse = xmlToJson(this.responseXML)
        console.log('asstesResponse==>', asstesResponse);
        if (asstesResponse['soapenv:Envelope']['soapenv:Body']) {
          _addNewContentModel.media_id = asstesResponse['soapenv:Envelope']['soapenv:Body']['ns2:createAssetsResponse'].asset.assetId;
          _addNewContentModel.media_url = asstesResponse['soapenv:Envelope']['soapenv:Body']['ns2:createAssetsResponse'].asset.group.item.uri;
          _addNewContentModel.media_type = asstesResponse['soapenv:Envelope']['soapenv:Body']['ns2:createAssetsResponse'].asset.group.item.type;
          if (_addNewContentModel.media_type === 'text' || _addNewContentModel.media_type === 'application') {
            _addNewContentModel.media_type = 'document';
          }
          var mime_type = asstesResponse['soapenv:Envelope']['soapenv:Body']['ns2:createAssetsResponse'].asset.group.item.filename.split('.');
          _addNewContentModel.media_mime_type = mime_type[mime_type.length - 1];
          _addNewContentModel.media_name = asstesResponse['soapenv:Envelope']['soapenv:Body']['ns2:createAssetsResponse'].asset.group.item.filename;

          console.log('Final JSON', JSON.stringify(_addNewContentModel));
          //it will create the new content
          _this.contentmangamentService.createNewContent(_addNewContentModel).subscribe(
            (response) => {
              _this.showFileUploadLoader = false;
              console.log('Return createNewContent response from CTL:', response);
              _this.message = response.message;
              // jQuery(_this.addContentModel.nativeElement).modal('hide');
              // jQuery(_this.successModal.nativeElement).modal('show');
            },
            (err) => {
              _this.showFileUploadLoader = false;
              const errorHandlerObj = new MyErrorHandler();
              const errorHandler = errorHandlerObj.handleError(err);
              if (_this.errorHandler.isSssionExpired) {
                _this.router.navigate(['/login']);
                return true;
              }
              _this.showErrorBox();
            },
            () => {
              console.log('COMPLETED');
            }
          )
        }
      }
    );
  }

  /***
   * this method will be used to get filtered content details
   */
  getFilterData(tab?) {
   // this.getMediaTypeData();
    this.isContentFound = false;
    this.contentDetails = new ContentData();
    let filterList = new Array<ContentData>();
    this.contentList = new Array<ContentData>();
    
    if(tab == 'allcontent'){
      this.filterCreteria = this.afilterCreteria;
      this.contentList = new Array<ContentData>();
      filterList = this.data;
    } else if(tab == 'myfavorite'){
      this.filterCreteria = this.ffilterCreteria;
      this.contentList = new Array<ContentData>();
      filterList = this.data;
    } else if(tab== 'mycontent'){
      this.filterCreteria = this.mfilterCreteria;
      this.teachercontentList = new Array<ContentData>();
      filterList = this.mycontentList;
    } else if(tab == 'dist'){
      this.filterCreteria = this.dfilterCreteria;  
      this.teacherdistributeList = new Array<ContentData>();
      filterList = this.distContentList;
    } else {
      this.contentList = new Array<ContentData>();
      filterList = this.data;
    }
      
    if(this.filterCreteria.subjectId && filterList) {
      if (Object.keys(this.filterCreteria.subjectId).length > 0) {
        filterList = filterList.filter(x => x.subject?._id === this.filterCreteria.subjectId._id);      
      }
    }    

    if(this.filterCreteria.languageId && filterList) {
      if (Object.keys(this.filterCreteria.languageId).length > 0) {
        filterList = filterList.filter(x => x.language._id === this.filterCreteria.languageId._id);
      }
    }    
    
    /* Ngx-select-dropdown grade / year filter */
    if(this.filterCreteria.yearNumber){
      if (Object.keys(this.filterCreteria.yearNumber).length > 0) {
        if(this.filterCreteria.yearNumber.year !== undefined){
          filterList = filterList.filter(x => {
            if (x.start_year && x.end_year) {
              return x.start_year.number <= this.filterCreteria.yearNumber.year.number && x.end_year.number >= this.filterCreteria.yearNumber.year.number
            }
            if (x.start_grade && x.end_grade) {
              return x.start_grade.year.number <= this.filterCreteria.yearNumber.year.number && x.end_grade.year.number >= this.filterCreteria.yearNumber.year.number
            }
          });
        }else{
          filterList = filterList.filter(x => {
            if (x.start_year && x.end_year) {
              return x.start_year.number <= this.filterCreteria.yearNumber.number && x.end_year.number >= this.filterCreteria.yearNumber.number
            }
            if (x.start_grade && x.end_grade) {
              return x.start_grade.year.number <= this.filterCreteria.yearNumber.number && x.end_grade.year.number >= this.filterCreteria.yearNumber.number
            }
          });
        }      
      }
    }
    


    //filter using source Id
    if(this.filterCreteria.sourceId) {
      if (Object.keys(this.filterCreteria.sourceId).length > 0) {
        filterList = filterList.filter(x => x.source._id === this.filterCreteria.sourceId._id);
      }
    }

    //filter using contant type
    if(this.filterCreteria.contentType) {
      if (Object.keys(this.filterCreteria.contentType).length>0 && this.filterCreteria.contentType.hasOwnProperty('name')) {
        const filter = this.filterCreteria.contentType.name.toLowerCase();
        filterList = filterList.filter(x => x.media_type.toLowerCase() === filter);
      }
    }
    if(this.filterCreteria.gradeName) {
      if (Object.keys(this.filterCreteria.gradeName).length>0) {
        filterList = filterList.filter(x => {
          if (x.classes) {
            const list = x.classes.filter(y => y.grade.name === this.filterCreteria.gradeName.name);
            if (list.length) {
              return true;
            }
            return false;
          } else if(x.groups) {
            const list = x.groups.filter(y => y.class.grade.name === this.filterCreteria.gradeName.name);
            if (list.length) {
              return true;
            }
            return false;
          }
          return false;
        });
      }
    }
    if(this.filterCreteria.classId) {
      if (Object.keys(this.filterCreteria.classId).length>0) {
        filterList = filterList.filter(x => {
          if (x.classes) {
            const list = x.classes.filter(y => y._id === this.filterCreteria.classId._id);
            if (list.length) {
              return true;
            }
            return false;
          } else if(x.groups) {
            const list = x.groups.filter(y => y.class._id === this.filterCreteria.classId);
            if (list.length) {
              return true;
            }
            return false;
          }
          return false;
        });
      }
    }
    
    if (tab === 'mycontent') {
      this.teachercontentList = [...filterList];
      this.contentList = [...filterList];
    } else if (tab === 'dist') {
      this.teacherdistributeList = [...filterList];
    } else {
      this.contentList = [...filterList];
    }

    if (this.contentList.length > 0) {
      this.contentDetails = this.contentList[0];
      this.highLightRow = 0;
      this.isContentFound = true;
    }
    
    if(this.firstTime){
      this.subjects = [];
      const tempSubArr = [];
      const tempLangArr = [];
      const tempSourceArr = [];
      const tempType = [];
      const tempYears = [];
      const tempGrades = [];
      this.ftempSubArr = [];
      this.fTempGradeArr = [];
      this.ftempLangArr = [];
      this.ftempSourceArr = [];
      this.ftempType = [];
      this.ftempYears = [];
      const availableYears = [];
      const availableGrades = [];
      const featuredYears = [];
      const featuredGrades = [];
      for (var i=0;i<this.contentList.length;i++){   
        if(this.contentList[i].subject) {
          this.subjects.push(this.contentList[i].subject);
        }         
        
        tempLangArr.push(this.contentList[i].language);
        tempSourceArr.push(this.contentList[i].source);
        if(this.loggedInUser.role.name === 'GeneralAdmin'){          
          for(let kk=this.contentList[i].start_year.number; kk <= this.contentList[i].end_year.number; kk++){
            if(availableYears.length > 0){
              if (availableYears.findIndex(x => x._id === this.yearsDD[kk-1]._id) === -1){
                availableYears.push(this.yearsDD[kk-1]);
              }
            }else{
              availableYears.push(this.yearsDD[kk-1]);
            }        
          }
          tempYears.push(this.contentList[i].start_year);
          tempYears.push(this.contentList[i].end_year);
        }
        else{
          let start_grade =  this.contentList[i].start_grade;
          start_grade.number =  this.contentList[i].start_grade.year.number;
          let end_grade = this.contentList[i].end_grade;
          end_grade.number = this.contentList[i].end_grade.year.number;
         // tempGrades.push(this.contentList[i].start_grade);
          //tempGrades.push(this.contentList[i].end_grade);
          tempGrades.push(start_grade);
          tempGrades.push(end_grade);
          
          for(let kk=this.contentList[i].start_grade.year.number; kk <= this.contentList[i].end_grade.year.number; kk++){
            if(availableGrades.length > 0){
              if (this.gradesDD.length > (kk-1) && availableGrades.findIndex(x => x._id === this.gradesDD[kk-1]._id) === -1){
                if(this.gradesDD.length > (kk-1) && this.gradesDD[kk-1]){
                  availableGrades.push(this.gradesDD[kk-1]);
                }                
              }
            }else{
              if(this.gradesDD.length > (kk-1) && this.gradesDD[kk-1]){
                availableGrades.push(this.gradesDD[kk-1]);
              }  
            }        
          }
         
        }
        if (this.types){
          const tempR = this.types.filter( type => this.contentList[i].media_type === type.name.toLowerCase());
          tempType.push(tempR[0]);
        }

        if (this.contentList[i].favorite === true){
          if (this.loggedInUser.role.name === 'GeneralAdmin'){
            this.ftempYears.push(this.contentList[i].start_year);
            this.ftempYears.push(this.contentList[i].end_year);
            for(let kk=this.contentList[i].start_year.number; kk <= this.contentList[i].end_year.number; kk++){
              if(featuredYears.length > 0){
                if (featuredYears.findIndex(x => x._id === this.yearsDD[kk-1]._id) === -1){
                  featuredYears.push(this.yearsDD[kk-1]);
                }
              }else{
                featuredYears.push(this.yearsDD[kk-1]);
              }        
            }
          }
          else{
            this.fTempGradeArr.push(this.contentList[i].start_grade);
            this.fTempGradeArr.push(this.contentList[i].end_grade);
            for(let kk=this.contentList[i].start_grade.year.number; kk <= this.contentList[i].end_grade.year.number; kk++){
              console.log(featuredGrades);
              console.log(featuredGrades.length);
              if(featuredGrades.length > 0){
                if (this.gradesDD.length > (kk-1) && featuredGrades.findIndex(x => x._id === this.gradesDD[kk-1]._id) === -1){
                  if(this.gradesDD.length > (kk-1) && this.gradesDD[kk-1]){
                    featuredGrades.push(this.gradesDD[kk-1]);
                  }  
                }
              }else{
                if(this.gradesDD.length > (kk-1) && this.gradesDD[kk-1]){
                  featuredGrades.push(this.gradesDD[kk-1]);
                }                
              }        
            }
          }
          if(this.contentList[i].subject){
            this.ftempSubArr.push(this.contentList[i].subject);
          }
          
          this.ftempLangArr.push(this.contentList[i].language);
          this.ftempSourceArr.push(this.contentList[i].source);
          if (this.types){
            const result = this.types.filter( type => this.contentList[i].media_type==type.name.toLowerCase());
            this.ftempType.push(result[0]);
          }
        }
      }
      this.ayears = availableYears;
      this.fyears = featuredYears;
      // this.subjects = tempSubArr;
      this.languages = tempLangArr;
      for (const language of this.languages) {
        language['custom'] = language.name.charAt(0).toUpperCase() + language.name.slice(1);
      }          
     
      //  if(this.contentList.length && this.loggedInUser.role.name === 'GeneralAdmin'){
        // let sortedatempyears = tempYears.sort(this.GetSortOrder('number')); 
        // let sortedftempYears = this.ftempYears.sort(this.GetSortOrder('number')); 
      
        // for(var i=0;i<this.yearsDD.length;i++){      
        //  if(this.yearsDD[i].number <= sortedatempyears[sortedatempyears.length-1].number)  {        
        //    this.ayears.push(this.yearsDD[i]);
        //  }  
        //  if(this.yearsDD[i].number <= sortedftempYears[sortedftempYears.length-1].number)  {        
        //   this.fyears.push(this.yearsDD[i]);
        //  } 
      //  }
      // }
    
      if (this.loggedInUser.role.name !== 'GeneralAdmin'){     
        // let sortedtempGrades=tempGrades.sort(this.GetSortOrder('number'));  
        // let sortedfTempGradeArr=this.fTempGradeArr.sort(this.GetSortOrder('number'));  
        // console.log("---sortedfTempGradeArr---"+JSON.stringify(sortedfTempGradeArr));
        // for(var i=0;i<this.gradesDD.length;i++){        
        // if(this.gradesDD[i].number <= sortedtempGrades[sortedtempGrades.length-1].number)  {          
        //   this.agrades.push(this.gradesDD[i]);
        // }
        // if(this.gradesDD[i].number <= sortedfTempGradeArr[sortedfTempGradeArr.length-1].number)  {          
        //   this.fagrades.push(this.gradesDD[i]);
        // }
        // }
        this.agrades = availableGrades;
        this.fagrades = featuredGrades;
      }
      
      this.sources = tempSourceArr;
      this.atypes = tempType;
      this.years = this.ayears;
      
      //this.grades = tempGrades;
      this.grades = this.agrades;

      this.fsubject = this.ftempSubArr;
      this.flanguages = this.ftempLangArr;
      for (const flanguage of this.flanguages) {
        flanguage['custom'] = flanguage.name.charAt(0).toUpperCase() + flanguage.name.slice(1);
      }
     // this.fgrades = this.fTempGradeArr;
      this.fgrades = this.fagrades; 
      this.fsource = this.ftempSourceArr;
      this.ftype = this.ftempType;
      this.fYears = this.fyears;
      this.firstTime = false;
    }
  }


  onItemSelect(item: any) {
    this.projectValidation = '';
  }

  OnItemDeSelect(item: any) {
    console.log(item);
    console.log(this.selectedItems);
  }

  onSelectAll(items: any) {
    console.log(items);
  }

  onDeSelectAll(items: any) {
    console.log(items);
  }

  /***
    * this method will be  used to open add content data modal
   */
  addContentModal() {
    this.addNewContentModel = new AddContent();
    this.tagsString = '';
    this.fileName = null;
    this.createMultiSelectPorjectList();
    if (this.userDetails.role.name === 'ContentProvider' ||
      this.userDetails.role.name === 'GeneralAdmin' ||
      this.userDetails.role.name === 'ProjectAdmin' ||
      this.userDetails.role.name === 'SchoolAdmin') {
        this.addNewContentModel.status = '1';
    } else {
        this.addNewContentModel.status = '3';
    }
    this.btnTextCancel = 'Cancel';
    this.btnStatusAdd = false;
    this.btnTextAdd = this.translate.instant('Upload');
    this.openDialogModal('addContentModel');
  }

  /***
  * this method will be used to open edit content data modal and also to load default data of modal
  */
 editContentModal() {
   this.closeDialogModal('viewContentModel');
   this.addNewContentModel = new AddContent();
   this.addNewContentModel.tags = [];
   this.cmviewType = 'edit';
   this.setContentFormData(this.contentDetails);
   this.addNewContentModel.media = this.contentDetails.media;
   this.addNewContentModel.subject_id = this.contentDetails.subject?._id;
   this.addNewContentModel.media_type = this.contentDetails.media_type;
   this.tagsString = this.addNewContentModel.tags.toString();
   this.getTopicData();
   if (this.tagsString) {
     const tags = this.tagsString.split(',');
     this.count = tags.length;
   }
   this.openDialogModal('editContentModel');
 }

  distContentModal() {
    this.closeDialogModal('viewContentModel');
    this.cmviewType = 'distribute';
    this.openDialogModal('distributeContentModel');
  }

  /***
    * this method will be used to delete content
   */
  deleteContent() {
    this.deleteAssets();
    this.closeDialogModal('deleteConfirmModal');
    this.titleMessage = this.translate.instant('Content')+" "+this.translate.instant('Deleted');
    this.subTitleMessage = this.contentDetails.title;
    this.detailMessage = "";
    this.detailMessage1 = '';
    this.detailMessage2 = '';
    this.openDialogModal('successModal');
  }

  showDeleteConfirm(){
    this.titleMessage = this.translate.instant('Delete this content?');
    this.subTitleMessage = this.contentDetails.title;
    //this.detailMessage = "";
    this.detailMessage = this.translate.instant('This content will be removed from the Connect to Learn system');
    this.closeDialogModal('editContentModel');
    this.openDialogModal('deleteConfirmModal');
  }

  /***
    * this method will be  used to delete assets
   */
  deleteAssets() {
    var _this = this;
    _this.contentmangamentService.deleteContent(_this.contentDetails._id).subscribe(
      (response) => {
        console.log('Delete content: ' + JSON.stringify(response)),
        _this.deleted = true;
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        _this.errorHandler = errorHandlerObj.handleError(err);
        _this.showErrorBox();
      },
      () => {
        console.log('COMPLETED');
        this.refreshContentPageData();
      }
    );
  }

  /***
   * This method is used to handle the msdp errors
   */
  private handleMsdpError(this, _this) {
    var errorResponse = xmlToJson(this.responseXML);
    console.log('msdp update error resp==>', errorResponse);
    if (errorResponse['soapenv:Envelope']['soapenv:Body']['soapenv:Fault']) {
      _this.errorMessage = errorResponse['soapenv:Envelope']['soapenv:Body']['soapenv:Fault'].faultstring;
      // jQuery(_this.errorMessageModal.nativeElement).modal('show');
    }
  }

  /*
  * Method is used to validate Tags limit. It will allow upto 3 Tags only comma seprated
  */
   validateTag(event: any, tagsString?: any) {
    if (this.tagsString) {
      const tags = this.tagsString.split(',');
      if (tags.length){
        this.count = tags.length;
      }
    }
    if (event.charCode === 44) {
      if (this.count > 4) {
        event.preventDefault();
      }
      this.count++;
    }
  }

  /*
  * Method is used to record the keypress of title and description
  */
   validate(event: any) {

  }

  /***
   * this method will be used to set content data from response object to edit content data model
   */

  public setContentFormData(contantData?: ContentData) {
    this.addNewContentModel = new AddContent();
    this.addNewContentModel.media = contantData.media;
    this.addNewContentModel.media_name = contantData.media_name;
    this.addNewContentModel.media_id = contantData.media_id;
    this.addNewContentModel.media_url = contantData.media_url;
    this.addNewContentModel.media_type = contantData.media_type;
    this.addNewContentModel.media_mime_type = contantData.media_mime_type;
    this.addNewContentModel.title = contantData.title;
    this.addNewContentModel.description = contantData.description;
    this.addNewContentModel.subject_id = contantData.subject?._id;
    if (contantData.topic) {
      this.addNewContentModel.topic_id = contantData.topic._id;
    }
    if (contantData.start_year) {
      this.addNewContentModel.start_year_id = contantData.start_year._id;
    }
    if (contantData.end_year) {
      this.addNewContentModel.end_year_id = contantData.end_year._id;
    }
    if (contantData.start_grade) {
      this.addNewContentModel.start_year_id = contantData.start_grade.year_id;
    }
    if (contantData.end_grade) {
      this.addNewContentModel.end_year_id = contantData.end_grade.year_id;
    }
    this.addNewContentModel.duration = contantData.duration;
    this.addNewContentModel.source_id = contantData.source._id;
    this.addNewContentModel.language_id = contantData.language._id;
    this.addNewContentModel.tags = contantData.tags;
    this.addNewContentModel.published_to = contantData.published_to;
    if (contantData.status === 'Published') {
      if (contantData?.published_to?.projects) {
        this.addNewContentModel.status = '1';

        this.createMultiSelectPorjectList();
        this.selectedItems = [];

        for (var index = 0; index < contantData.published_to.projects.length; index++) {
          const projects = this.projects.filter(x => x._id === contantData.published_to.projects[index]);
         // console.log("Projects >>> ",JSON.stringify(projects));
          if (projects) {
            const selectedProjectValue = new MultiselectProjectValue();
            selectedProjectValue.id = projects[0]._id;
            selectedProjectValue.itemName = projects[0].name;
            this.selectedItems.push(selectedProjectValue);
            this.selectedProjectsMap[projects[0]._id] = true;
          }
        }
      } else {
        this.addNewContentModel.status = '2';
      }
    } else if (contantData.status === 'Unpublished') {
      this.addNewContentModel.status = '3';
    }
  }

  /**
   * Validation Code for restrict character for input box. Allow only number to be input
   */

  _keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (event.keyCode !== 8 && !pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }
  /**
    *  code for show possible error in notification form
    */
  showErrorBox() {
    this.showLoader = false;
    this.isContentFound = false;
    const x = document.getElementById('snack-error-bar');
    x.className = 'show';
  }

  closeErrorDiv() {
    const x = document.getElementById('snack-error-bar');
    x.className = x.className.replace('show', '');
  }
  GetSortOrder(prop) {
    return (a, b) => {
        if (a[prop] > b[prop]) {
            return 1;
        } else if (a[prop] < b[prop]) {
            return -1;
        }
        return 0;
    };
  }
  setGrid(suffix) {
    switch (suffix) {
      case 'A': {
        this.gridViewA = true;
        this.gridSelectedA = true;
        break;
      }
      case 'F': {
        this.gridViewF = true;
        this.gridSelectedF = true;
        break;
      }
      case 'M': {
        this.gridViewM = true;
        this.gridSelectedM = true;
        break;
      }
    }
    this.noOfItems = 9;
   }


   setList(suffix) {
    switch (suffix) {
      case 'A': {
        this.gridViewA = false;
        this.gridSelectedA = false;
        break;
      }
      case 'F': {
        this.gridViewF = false;
        this.gridSelectedF = false;
        break;
      }
      case 'M': {
        this.gridViewM = false;
        this.gridSelectedM = false;
        break;
      }
    }
    this.noOfItems = 10;
  }

   setListViewbyClass() {
    this.myview = 'listbyClass';
   // alert("setListViewbyClass")
    //this.getfilteredData('default', 'default');
  }

  setListViewbyContent() {
    this.myview = 'listbyContent';
  }

  onTabChange(tabname)
  {
   //console.log("tabname--"+tabname);
    this.firstTime=true;
    this.myview = 'listbyClass';
    if (tabname === 'distribution'){
        this.currentTab = 'mydistribution';
        // this.getClassRoomList();
        if (this.classRoomList){
          this.classRoomList.forEach(classroom => {
            this.setDistributionValues(classroom._id);
          });
        }
    }else if (tabname === 'allcontent'){
      this.currentTab = 'allcontent';   
      this.getFilterData();
    }else if (tabname === 'mycontent'){
        this.currentTab = 'mycontent';
        this.filterCreteria = new FilterCriteria();
        this.getFilterData('mycontent');
    } else if (tabname === 'myfavorite'){
        this.currentTab = 'myfavorite';
        this.filterCreteria = new FilterCriteria();
        this.getFilterData();
    }
  }

  /* distribute content */
  toggleSelectionForClass(ev,id) {
    this.isUpdate = true;
    this.validationMsg = '';
    if (ev.target.checked) {
      const idx = this.classList.indexOf(id);
      if (idx === -1) {
        this.classList.push(id);
      }
      if(this.classRoomList.length === this.classList.length){
        this.isAllSelected = true;
      }
    } else {
      const idx = this.classList.indexOf(id);
      if (idx > -1) {
        this.classList.splice(idx, 1);
      }
      this.isAllSelected = false;
    }
    this.disableDistribute = false;
    // if(this.classList.length>0){
    //   this.disableDistribute = false;
    // }else{
    //   this.disableDistribute = true;
    // }
  }

  toggleSelectionForGroup(ev,id) {
    this.isUpdate = true;
    this.validationMsg = '';

    if (ev.target.checked) {
      const idx = this.groupList.indexOf(id);
      if (idx === -1) {
        this.groupList.push(id);
      } 
    }
    else {
      const idx = this.groupList.indexOf(id);
      if (idx > -1) {
        this.groupList.splice(idx, 1);
      }
    }
    this.disableDistribute = false;
    // if(this.groupList.length>0){
    //   this.disableDistribute = false;
    // }else{
    //   // this.disableDistribute = true;
    // }
  }

  addTopic(name) {
    let topicData;
    if (name) {
      topicData = {
        name: name.charAt(0).toUpperCase() + name.slice(1),
        subject_id: this.addNewContentModel.subject_id
      };

      this.contentmangamentService.addNewTopic(topicData).subscribe(
        (response) => {
          //
          if (response.topic_id) {
            this.getTopicData();
            this.addNewContentModel.topic_id = response.topic_id;
          }
        },
        (err) => {
          const errorHandlerObj = new MyErrorHandler();
          this.errorHandler = errorHandlerObj.handleError(err);
          if (this.errorHandler.isSssionExpired) {
            this.router.navigate(['/login']);
            return true;
          }
        },
        () => {
          console.log('COMPLETED');
        }
      )
    }
  }

  selectedTopic() {
    console.log('topic selected ==' + this.addNewContentModel.topic_id);
  }

  /** This method is used to call service for add content to particular Unit from existing content material*/

  addContentToUint(contentId) {
    this.showLoader = true;
    this.contentmangamentService.addContentToUnit(this._curriculumData, contentId).subscribe(
      (response) => {
        console.log('Add content To Unit Response', response);
        this._curriculumData.content = this.contentDetails || this.addNewContentModel;
        window.localStorage.setItem('curriculumData', JSON.stringify(this._curriculumData));
        this._curriculumData = {};
        // jQuery('#successModal').modal('show');
        // redirect back to curriculum plan;
        // this.router.navigate(['/curriculumplan/view']);
        // jQuery(this.viewContentModel.nativeElement).modal('hide');
        this.router.navigate(['../'], { relativeTo: this.route });
        this.showLoader = false;
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        this.errorHandler = errorHandlerObj.handleError(err);
        if (this.errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
        this.showErrorBox();
      },
      () => {

        console.log('COMPLETED');
      }
    )
  }

  getYearNumber(data) {
    if ((!data.start_grade || !data.start_grade.year) && !data.start_year) {
      return '';
    }
    if (data.start_year && data.end_year) {
      return 'Year ' + data.start_year.number + ' - ' + data.end_year.number;
    }
    if (data.start_grade && data.end_grade) {
      return 'Grade ' + data.start_grade.year.number + ' - ' + data.end_grade.year.number;
    }
    return '';
  }

  isGroupShared(cl, gr?) {
    if (!gr || !gr.length) {
      return false;
    }
    const y = gr.filter(x => x.class._id === cl._id);
    if (y && y.length) {
      return true;
    }
    return false;
  }

  setFavorite(item) {
    const data = {favorite: false};
    if (item.favorite === false) {
      data.favorite = true;
      item.favorite = true;
      console.log(item);

    }
    else if (item.favorite === true) {
      data.favorite = false;
      item.favorite = false;
     // console.log(item);

    } else {
      data.favorite = true;
      item.favorite = true;
      console.log(item);
    }

    this.contentmangamentService.setFavorite(item._id, data).subscribe(
      (response) => {
        this.refreshContentPageData();
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        this.errorHandler = errorHandlerObj.handleError(err);
        if (this.errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
        this.showErrorBox();
      },
      () => {

       // console.log("COMPLETED");
      }
    );
  }

  isDistributed() {
    const distContent =  this.teacherdistributeList.filter(x => x._id === this.contentDetails._id)[0];
    if (distContent && distContent.classes){
      return true;
    }
    if (distContent && distContent.groups){
      return true;
    }
    return false;
  }

  isCheckedGroup(group_id){
    const idx = this.groupList.indexOf(group_id);
    if(idx > -1){
      return true;
    } else {
      return false;
    }
  }
  
  isDistributedToClassGroup(class_id, group_id?) {
    const distContent =  this.teacherdistributeList.filter(x => x._id === this.contentDetails._id)[0];
    if (distContent && distContent.classes && class_id) {
      const res = distContent.classes.filter(x => x._id === class_id)[0];
      if (res) {   
        return true;
      }
      return false;
    }
    if (distContent && group_id && distContent.groups) {
      const res = distContent.groups.filter(x => x._id === group_id)[0];
      if (res) {     
        return true;
      }
      return false;
    }
    return false;
  }

  setDistributionValues(class_id, group_id?){
    const distContent =  this.teacherdistributeList.filter(x => x._id === this.contentDetails._id)[0];
    if (distContent && distContent.classes && class_id) {
      const res = distContent.classes.filter(x => x._id === class_id)[0];
      if (res) {
        if (this.classList.indexOf(class_id) < 0){
          this.classList.push(class_id);
          console.log('connect to learn');
        }
      }
    }
    if (distContent && group_id && distContent.groups) {
      const res = distContent.groups.filter(x => x._id === group_id)[0];
      if (res) {
        if (this.groupList.indexOf(group_id) < 0){
          this.groupList.push(group_id);
          console.log('connect to learn1');
        }
      }
    }
  }
  /* Sorting functionality added - KAJAL */
  sortByDefault(propertyName){
    this.isSorted = true;
    this.sortedClass = '';
    this.propertyName = propertyName;
    this.orderType = true;
    this.propertyNameSorting = propertyName;
  }
  sortBy(propertyName){
    this.isSorted = true;
    this.sortedClass = '';
    this.propertyName = propertyName;
    if (propertyName !== null && this.propertyName === propertyName){
      if (this.orderType === true){
        this.orderType = false;
        this.propertyNameSorting = propertyName;
        this.sortedClass = 'asc';
      }else{
        this.orderType = true;
        this.propertyNameSorting = '-' + propertyName;
        this.sortedClass = 'desc';
      }
    }
  }
  setViewBy(data){
    if (data.value.name === 'List by class'){
      this.myview = 'listbyClass';
    } else if (data.value.name === 'List by content'){
      this.myview = 'listbyContent';
    } else{
      this.myview = 'listbyClass';
    }
  }
  openDialogModal(id){
    const dialogDOM = document.querySelector('#' + id) as HTMLElement;
    const dialog = new Dialog(dialogDOM);
    dialog.init();
    dialog.show();
  }

  closeDialogModal(id){
    const dialogDOM = document.querySelector('#' + id) as HTMLElement;
    const dialog = new Dialog(dialogDOM);
    dialog.init();
    dialog.hide();
  }
  downloadCsv(data, type){
    this.util.generateCSV(data, type);
  }
}
